module.exports = __webpack_public_path__ + "static/hplogo-742fa59d6924dce46f1824d7e8573ed3.png";